import { tracked } from '@glimmer/tracking';

import FilterSortGoalTeams from 'webapp/models-custom/filter-sort/goal-teams';

export default class FilterSortGoalTeamsInList extends FilterSortGoalTeams {
	@tracked override viewId = 'table';
	override itemDomSelector = '.table-row:not(.empty)';
}
